import React from 'react';
import { useSelector } from 'react-redux';
import BaseAlert from 'components/Alert';
import Button from 'products/nomad_insurance/components/Button';
import styled from 'styled-components';
import { th } from 'style/theme';

const Alert = styled(BaseAlert)`
  color: ${th('colors.pickledBluewood')};
  border: 1px solid ${th('colors.porsche-2')};
  border-radius: 16px;
  padding: 16px;
  padding-bottom: 24px;
  margin-top: 28px;

  > h6 {
    display: flex;
    gap: 4px;
    font-weight: 500;

    > svg {
      fill: ${th('colors.porsche-2')};
      font-size: 20px;
    }
  }

  > p {
    padding-left: 28px;
    font-size: 16px;

    > ul {
      padding-left: 14px;
    }
  }
`;

const AlertButton = styled(Button)`
  margin-top: 8px;
  border-radius: 12px;
`;

const SubscriptionAlert = ({
  switchToSubscription
}: {
  switchToSubscription: () => void;
}) => {
  const { contract: cancelledContract } = useSelector(
    (state: any) => state.nomadInsurance.contract.lastCancelledContract
  );

  const isZeroDeductible = cancelledContract?.deductible !== 250;

  return (
    <Alert
      variant="warning"
      label="By choosing to pay upfront for this policy:"
      onClear={undefined} // TODO: Refactor alert to use typescript
    >
      <ul>
        {isZeroDeductible ? (
          <>
            <li>
              You cannot add extra coverage for adventure sports or electronics theft
            </li>
            <li>
              After this policy ends, your next policy won’t cover any new illnesses or
              symptoms that began during this coverage period
            </li>
            <li>
              You’ll have to contact Customer Care to cancel early, whereas subscription
              renewals can be stopped anytime in your dashboard
            </li>
          </>
        ) : (
          <>
            <li>
              The US$250 deductible resets for each new policy within a 364-day period
            </li>
            <li>
              Any medical issues that come up during this policy, even undiagnosed, will
              not be covered in your next policy
            </li>
            <li>
              You’ll have to contact Customer Care to cancel early, whereas subscription
              renewals can be stopped anytime in your dashboard
            </li>
          </>
        )}
      </ul>

      <AlertButton
        onClick={switchToSubscription}
        variant="outline"
        color="pickledBluewood"
        thickness="thin"
      >
        Pay as you go instead
      </AlertButton>
    </Alert>
  );
};

export { SubscriptionAlert };
